var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isGeneric ? _c('div', {
    staticClass: "json_payload_view"
  }, [_c('p', [_vm._v("{ }")])]) : _c('GenericPayloadViewSmall', {
    attrs: {
      "payload": _vm.payload
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }